export default __webpack_public_path__ + "static/media/Harmonics.a72c4ce0.mp3";